export default {
  normal: 400,
  bold: 700
};
